import { GetterTree } from 'vuex';
import { RootState } from './types';
import { StoreState } from '@/types';
import AccountHelpers from '@/models/account';

const billingIntervalNames: any = {
  year: "Annual",
  month: "Monthly",
  once: "Once off",
};

const rootGetters: GetterTree<RootState, StoreState> = {
  state: (state) => state.state,
  lastErr: (state) => state.lastErr,

  tzName: (state) => state.timezone,

  // order info getters
  packageGroups: (state) => state.packageGroups,
  packages: (state) => state.packages,
  displayPackageGroups: (state) => {
    if (!state.packageGroups) { return []; }
    const packageGroupCopy = JSON.parse(JSON.stringify(state.packageGroups));

    const grps: any = [];
    for (const g of packageGroupCopy) {
      g.qty = 1;
      g.discount = 0;
      g.selectedPackage = undefined;

      const packages = g.packages
        .sort((a: any, b: any) =>
          a.code < b.code ? -1 : a.code > b.code ? 1 : 0,
        )
        .map((p: any) => {
          p.title = p.title
            .replace(`${g.title} - `, "")
            .replace(`${g.title} `, "");
          const intervalName = billingIntervalNames[p.interval] || "";
          p.title += intervalName ? " - " + intervalName : "";
          return p;
        });

      if (packages.length) {
        g.packages = packages;
        grps.push(g);
      }
    }
    return grps;
  },
  salesConsultants: (state) => state.salesConsultants,

  // pivot info getter
  views: (state) => state.views,

  serviceMatrix: (state) => state.serviceMatrix,
  warehouses: (state) => state.warehouses,
  warehousepackages: (state) => state.warehousepackages,

  // global account getters
  globalSelectedAccount: (state) => state.globalSelectedAccount,
  globalSelectedAccountDisplayText: (state) => {
    return AccountHelpers.DisplayText(state.globalSelectedAccount);
  },

  snackbarState: (state) => state.snackbarState,
  snackbarText: (state) => state.snackbarText,
};

export default rootGetters;
